export const TYPE_MAP: Record<string, string> = {
    ticket: "ticket",
    incidente: "incident",
    problema: "problem",
    pergunta: "question",
    tarefa: "task",
};
